var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v(_vm._s(_vm.schema.$title))]),_c('w-input',{staticClass:"mt-3",attrs:{"model":_vm.schema.epuapAddress}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }